import { ILatLng, Marker } from "@ionic-native/google-maps";

export class PontoShapeModel {
	
	private _middle: boolean;
	private _selected: boolean = false;

	constructor(
		public latLng: ILatLng,
		public marker: Marker) {
	}

	public destroyMarker(): void {
		if (this.marker) {
			this.marker.remove();
		}
	}

	public changePosition(newPosition: ILatLng): void {
		this.latLng = newPosition;
		this.marker.setPosition(newPosition);
	}
	
	public isMiddlePoint(): boolean {
		return this._middle;
	}

	public setMiddlePoint(middle: boolean): void {
		this._middle = middle;
	}

	public isSelected(): boolean {
		return this._selected;
	}

	public setSelected(selected: boolean): void {
		if (this._selected == selected) return;

		this._selected = selected;
		
		if (this._selected) {
			this.marker.setIcon({ url: './assets/imgs/marker-move.png' });
			//this.marker.setDraggable(true);
		} else {
			this.marker.setIcon({ url: './assets/imgs/marker-point.png' });	
			//this.marker.setDraggable(false);
		}
	}

	public unselectIfDiff(pointDiff: PontoShapeModel): void {
		if (pointDiff != this) {
			this.setSelected(false);
		}
	}
}